import React, { Component } from "react";
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Grid,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Button,
  Modal,
  Radio,
  DropdownButton
} from "react-bootstrap";
import { DateTimePicker } from "react-widgets";
const axios = require("axios");

class Configuracion extends Component {
  componentDidMount() {
    this.setState({ periodo: "1", option: "0" });
  }
  getInicioState = () => {
    const length = this.state.desfechastartevent;
    if (length > 0) return "success";
    else return "error";
  };

  getFinState = () => {
    const length = this.state.desfechaendevent;
    if (length > 0) return "success";
    else return "error";
  };

  getDate = date => {
    var tdate =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      date.getHours() +
      ":" +
      date.getMinutes();
    return tdate;
  };

  getOnlyDate = date => {
    var tdate =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    return tdate;
  };

  handleSave = e => {
    e.preventDefault();
    let length = this.state.desfechastartevent;
    if (length === 0) return;
    length = this.state.desfechaendevent;
    if (length === 0) return;
    let des = "deshabilitar";
    let sDate = null;
    let eDate = null;

    console.log(this.state.periodo);
    if (this.state.periodo === "1") {
      des += "Dias";
      sDate = this.getDate(new Date(this.state.desfechastartevent));
      eDate = this.getDate(new Date(this.state.desfechaendevent));
    } else if (this.state.periodo === "2") {
      des += "Maniana";
      sDate = this.getOnlyDate(new Date(this.state.desfechastartevent));
      eDate = this.getOnlyDate(new Date(this.state.desfechaendevent));
    } else if (this.state.periodo === "3") {
      des += "Tarde";
      sDate = this.getOnlyDate(new Date(this.state.desfechastartevent));
      eDate = this.getOnlyDate(new Date(this.state.desfechaendevent));
    }
    this.deshabilitarTurnoAPI(des, sDate, eDate, this.state.option);
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  deshabilitarTurnoAPI = (des, sDate, eDate, option) => {
    axios
      .post(
        "http://190.105.227.203/turnos/" + des,
        {
          professionalId: this.props.professionalId,
          startdate: sDate,
          enddate: eDate,
          option: option
        },
        {
          headers: { Authorization: "Bearer " + this.props.token }
        }
      )
      .then(response => {
        console.log(response);
        if (response.status === 200) {
          this.setState({
            show: true,
            modaltitle: "",
            modalbody: "Cambio realizado"
          });
        } else {
          this.setState({
            show: true,
            modaltitle: "",
            modalbody: "Ocurrió un error al intentar realizar el cambio"
          });
        }
      })
      .catch(error => {});
  };

  onChangePeriodo = () => {
    this.setState({ periodo: this.inputEl.value });
  };

  onOptionChange = () => {
    this.setState({ option: this.optionEl.value });
  };
  state = {};
  render() {
    return (
      <div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modaltitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.state.modalbody}</Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Cerrar</Button>
          </Modal.Footer>
        </Modal>

        <Grid>
          <Row>
            <h4>Configuracion</h4>
          </Row>
          <Row>
            <h5 />
          </Row>
          <Row>
            <form>
              <FormGroup controlId="formControlsSelect">
                <ControlLabel>Tipo Cambio</ControlLabel>

                <FormControl
                  id={`dropdown-basic-1`}
                  componentClass="select"
                  inputRef={el => (this.optionEl = el)}
                  onChange={this.onOptionChange}
                >
                  <option value="0">Deshabilitar Turnos</option>
                  <option value="1">Habilitar Turnos</option>
                </FormControl>
                <ControlLabel>Periodo</ControlLabel>

                <FormControl
                  id={`dropdown-basic-1`}
                  componentClass="select"
                  title="Elegir..."
                  inputRef={el => (this.inputEl = el)}
                  onChange={this.onChangePeriodo}
                >
                  <option value="1">Todo el Día</option>
                  <option value="2">Mañana</option>
                  <option value="3">Tarde</option>
                </FormControl>
              </FormGroup>
              <FormGroup
                controlId="Desde"
                validationState={this.getInicioState()}
              >
                <ControlLabel>Inicio: </ControlLabel>
                <DateTimePicker
                  value={this.state.desfechastartevent}
                  step={20}
                  format={"dd/MM/yyyy HH:mm"}
                  onChange={value =>
                    this.setState({ desfechastartevent: value })
                  }
                />
                <FormControl.Feedback />
              </FormGroup>
              <FormGroup controlId="Hasta" validationState={this.getFinState()}>
                <ControlLabel>Fin: </ControlLabel>
                <DateTimePicker
                  value={this.state.desfechaendevent}
                  format={"dd/MM/yyyy HH:mm"}
                  //   format={{ raw: "MMM dd, yyyy" }}
                  step={20}
                  onChange={value => this.setState({ desfechaendevent: value })}
                />
                <FormControl.Feedback />
              </FormGroup>

              <Button onClick={this.handleSave} type="submit" bsStyle="primary">
                Cambiar
              </Button>
            </form>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Configuracion;



// WEBPACK FOOTER //
// ./src/components/configuracion.jsx